import { useEffect, useMemo, useState } from 'react';

import { SharedState } from './SharedState';

export function useSharedState<Value>(
  state: SharedState<Value>,
): [Value, SharedState<Value>['setValue']] {
  const [value, setValue] = useState(state.value);
  // Provide a stable reference to this bound function via `useMemo`
  const stateSetValue = useMemo(() => state.setValue.bind(state), [state]);

  useEffect(() => {
    return state.subscribe(setValue);
  }, [state, setValue]);

  return [value, stateSetValue];
}
